import InfiniteScroll from "react-infinite-scroll-component";
import IncomingMessageIcon from "../Svgs/IncomingMessageIcon";
import OutgoingMessageIcon from "../Svgs/OutgoingMessageIcon";
import { formatDateForChat } from "../../_helper";

const ListAdminMessages = ({
  messagesData = [],
  setCurrentMessageId,
  currentMessageId,
  messagesPagination,
  fetchMoreMessages,
  setSidebarMessagesToggle,
  isLoading,
}) => {
  return (
    <InfiniteScroll
      dataLength={messagesData.length}
      next={fetchMoreMessages}
      hasMore={messagesPagination.current_page < messagesPagination.last_page}
      loader={
        <p className="tw-text-center tw-text-gray-400 tw-my-5">
          Loading more...
        </p>
      }
      scrollableTarget="scrollableSidebar"
    >
      {messagesData.length < 1 && !isLoading && (
        <p className="tw-text-gray-400 tw-text-center !tw-mt-4">
          There are no messages to display.
        </p>
      )}

      {messagesData.map((m) => (
        <div
          key={m.id}
          onClick={() => {
            setCurrentMessageId(m.id);
            setSidebarMessagesToggle(false);
          }}
          className={`${
            currentMessageId === m.id ? "tw-bg-gray-200" : ""
          } tw-flex tw-items-center tw-p-2 hover:tw-bg-gray-100 tw-cursor-pointer tw-rounded-md`}
        >
          <div className="tw-w-12 tw-h-12 tw-bg-gray-300 tw-rounded-full tw-mr-3">
            <img
              src={m.userImage}
              alt="UserImage"
              className="tw-w-12 tw-h-12 tw-rounded-full"
            />
          </div>
          <div className="tw-flex-1">
            <div className="tw-flex tw-justify-between ">
              <h2 className="tw-text-base tw-font-semibold !tw-p-0 !tw-m-0 tw-text-ellipsis tw-line-clamp-1">
                {m?.userName?.split(" ")?.slice(0, 2)?.join(" ")}
              </h2>
              <div className="tw-flex tw-gap-2">
                <span>
                  {m.messageCategory === "Out" ? (
                    <OutgoingMessageIcon />
                  ) : (
                    <IncomingMessageIcon />
                  )}
                </span>
                <span className="tw-text-gray-400 tw-text-nowrap tw-text-[12px]">
                  {formatDateForChat(m.created_at)}
                </span>
              </div>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between">
              <p className="tw-text-gray-600 tw-break-words">
                {m.messageTitle.length > 10
                  ? `${m.messageTitle.slice(0, 10)}...`
                  : m.messageTitle}
              </p>

              {m.unSeenReplies > 0 && (
                <div className="tw-text-white tw-bg-primary tw-rounded-full tw-min-w-5 tw-min-h-5 tw-px-1 tw-text-sm tw-flex tw-items-center tw-justify-center">
                  {m.unSeenReplies}
                </div>
              )}

              {m.isNew && (
                <div className="tw-text-white tw-text-[12px] tw-bg-primary tw-rounded-full tw-min-w-5 tw-min-h-5 tw-px-1 tw-flex tw-items-center tw-justify-center">
                  New
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </InfiniteScroll>
  );
};

export default ListAdminMessages;
